// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("../../../../../Content/img/license.svg", import.meta.url);
// Module
var code = `<div class="modal-dialog" role="document">
    <div class="modal-content neo-modal force-text-wrap-word">
        <div class="modal-header">
            <button type="button" class="close" data-bind="click: close" aria-hidden="true">
                <i class="icon-cancel"></i>
            </button>
            <div data-bind="with: licenseLimitNotification">
                <h3 class="modal-title" data-bind="text: title"></h3>
                <div class="notification-time" data-bind="text: displayDate().format('LLL')"></div>
            </div>
        </div>
        <div class="modal-body">
            <div class="alert alert-warning align-items-start d-flex gap-3 mb-0">
                <img src="${___HTML_LOADER_IMPORT_0___}" width="60" class="img-responsive mx-auto">
                <p data-bind="html: licenseLimitNotification.message"></p>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bind="click: close">
                <i class="icon-cancel"></i><span>Close</span>
            </button>
            <a target="_blank" data-bind="click: register, attr: { 'href': requestLicenseUrl }" class="btn btn-primary">
                <i class="icon-license"></i>
                <span><span data-bind="text: licenseRequestType"></span> license</span>
            </a>
        </div>
    </div>
</div>
`;
// Exports
export default code;